"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPlane = function SvgPlane(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#17181A",
    d: "m10.937 12.507-3.323 2.038s-.882.686-2.545.343c-1.664-.343-3.37-.72-3.37-.72s-.365-.133-.618.194c-.252.326.163.521.163.521l2.566 1.858s.547.542 1.353.4c.805-.142 3.175-.623 3.175-.623s1.617-.346 3.54-1.545c1.924-1.2 8.8-5.372 8.8-5.372s2.675-1.521 2.407-2.158c-.268-.636-1.811-.466-2.549-.233-.737.233-6.494 3.496-6.494 3.496l-6.31-2.163s-.816-.194-.408.282c.408.477 4.406 4.456 4.406 4.456m1.564 2.263 1.714 1.71s.498.394.598-.979c.1-1.372.202-2.4.202-2.4"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgPlane);
var _default = exports["default"] = Memo;